var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":_vm.template,"height":_vm.height,"options":_vm.chartOptions,"series":_vm.verticalAxisSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }